import { useEffect } from 'react';
import { userNeedsSignInAction } from '@dtna/dvs-support-dcp-shared-state/lib/slices/user.slice';

import { useHostDispatch } from '../store';
import handleUserSignIn from '../services/user';

const useFetchUserData = () => {
  const dispatch = useHostDispatch();

  useEffect(() => {
    const fromRefresh = true;
    userNeedsSignInAction(null, fromRefresh)(dispatch);
    handleUserSignIn(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useFetchUserData;
